import { heroSlides } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20atmospheric%20sports%20arena%20at%20night%20with%20dynamic%20stadium%20lighting%2C%20golden%20and%20crimson%20color%20accents%2C%20modern%20architectural%20curves%2C%20misty%20atmosphere%2C%20professional%20sports%20photography%20style%2C%20epic%20scale%2C%20dark%20elegant%20background%20with%20warm%20highlight%20points%2C%20cinematic%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
          alt="开云体育平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-900/20 via-transparent to-primary-900/20"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <div className="animate-[fadeInUp_0.7s_ease-out]">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-background-50/90 font-medium">
              全球 5000万+ 用户信赖之选
            </span>
          </div>

          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight mb-5 tracking-tight">
            {heroSlides[0].title}
          </h1>
          <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
            {heroSlides[0].subtitle}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a
              href={heroSlides[0].ctaLink}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 dark:text-foreground-950 hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/30 hover:shadow-primary-500/50"
            >
              {heroSlides[0].cta}
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
            <a
              href={heroSlides[0].secondaryLink}
              className="w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold border-2 border-background-50/40 text-background-50 hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              {heroSlides[0].secondaryCta}
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
            {heroSlides[0].features.map((feature, idx) => (
              <div key={idx} className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15">
                  <i className="ri-check-line text-background-50 text-sm"></i>
                </div>
                <span className="text-sm md:text-base text-background-100 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}